export const configurationEnums = {
	WITHDRAWAL: "WITHDRAWAL",
	CATEGORISATION: "CATEGORISATION",
	PERSONAL_DATA: "PERSONAL_DATA",
	INVOICING_CONFIG: "INVOICING_CONFIG",
	CONTACTS: "CONTACTS"
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/configuration/enums/ConfigurationEnums.js